import search from './search'
import suggest from './suggest'

export default {
  search,
  suggest
}
